/**
 * Header component to show the project name and allow editing.
 * Supports projects in either lab2 or legacy lab mode.
 */
import React, { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { refreshProjectName } from '../../projectRedux';
import EditProjectName from './EditProjectName';
import DisplayProjectName from './DisplayProjectName';
import Lab2Registry from '@cdo/apps/lab2/Lab2Registry';
var EditableProjectName = function (_a) {
    var onChangedWidth = _a.onChangedWidth;
    var _b = useState(false), editName = _b[0], setEditName = _b[1];
    var legacyProjectName = useSelector(function (state) { return state.project.projectName; });
    var lab2ProjectName = useSelector(function (state) { var _a; return (_a = state.lab.channel) === null || _a === void 0 ? void 0 : _a.name; });
    var dispatch = useDispatch();
    useLayoutEffect(function () {
        if (onChangedWidth) {
            onChangedWidth();
        }
    });
    function beginEdit() {
        setEditName(true);
    }
    function finishEdit() {
        setEditName(false);
        if (!Lab2Registry.hasEnabledProjects()) {
            dispatch(refreshProjectName());
        }
    }
    function saveProjectName(newName) {
        var _a;
        if (Lab2Registry.hasEnabledProjects()) {
            return (_a = Lab2Registry.getInstance().getProjectManager()) === null || _a === void 0 ? void 0 : _a.rename(newName);
        }
        else {
            return dashboard.project.rename(newName);
        }
    }
    var projectName = Lab2Registry.hasEnabledProjects()
        ? lab2ProjectName || ''
        : legacyProjectName;
    if (editName) {
        return (React.createElement(EditProjectName, { finishEdit: finishEdit, projectName: projectName, saveProjectName: saveProjectName }));
    }
    else {
        return (React.createElement(DisplayProjectName, { beginEdit: beginEdit, projectName: projectName }));
    }
};
export default EditableProjectName;
